<template>
  <div>
    <div class="container drug-fact-container">
      <ul class="drug-tabs">
        <li
          class="drug-tab drug-tab--dark"
          :class="{ 'is-active': activeTab === 'list' }"
          @click="activeTab = 'list'"
        >
          <span class="icon icon--grid" aria-hidden="true"><grid-icon></grid-icon></span>
          Drug List
        </li>
        <li
          class="drug-tab drug-tab--light"
          :class="{ 'is-active': activeTab === 'wheel' }"
          @click="activeTab = 'wheel'"
        >
          <span class="icon icon--wheel" aria-hidden="true"><wheel-icon></wheel-icon></span>
          Drug Wheel
        </li>
        <li
          class="drug-tab drug-tab--alerts"
          :class="{ 'is-active': activeTab === 'alerts' }"
          @click="activeTab = 'alerts'"
        >
          <span class="icon icon--dangertriangle" aria-hidden="true">
            <danger-triangle></danger-triangle>
          </span>
          <span v-if="!isMobile"> Drug Alerts </span>
        </li>
      </ul>
    </div>
    <div v-if="activeTab === 'alerts'" class="full-width-border"></div>
    <drug-list :title="title" v-show="activeTab === 'list'" :pageId="pageId"></drug-list>
    <drug-wheel :title="title" v-show="activeTab === 'wheel'" :pageId="pageId"></drug-wheel>
    <drug-alerts v-show="activeTab === 'alerts'"></drug-alerts>
  </div>
</template>

<script>
import GridIcon from '@/components/svg/GridIcon.vue';
import WheelIcon from '@/components/svg/WheelIcon.vue';
import DangerTriangle from '@/components/svg/DangerTriangle.vue';
import { defineAsyncComponent } from 'vue';
import DrugList from './DrugList.vue';
import DrugAlerts from './DrugAlerts.vue';

export default {
  name: 'DrugFactIndex',
  components: {
    DangerTriangle,
    DrugList,
    DrugWheel: defineAsyncComponent(() => import('./DrugWheel.vue')),
    DrugAlerts,
    GridIcon,
    WheelIcon,
  },
  mounted() {
    this.checkIsMobile();
    this.updateTabFromHash();
    window.addEventListener('hashchange', this.updateTabFromHash);
    window.addEventListener('resize', this.checkIsMobile);
  },
  beforeUnmount() {
    window.removeEventListener('hashchange', this.updateTabFromHash);
    window.removeEventListener('resize', this.checkIsMobile);
  },
  props: ['title', 'pageId'],
  data() {
    return {
      activeTab: 'list',
      isMobile: false,
    };
  },
  methods: {
    checkIsMobile() {
      if (window.innerWidth <= 720) {
        this.isMobile = true;
      }
    },
    updateTabFromHash() {
      if (window.location.hash) {
        const tab = window.location.hash.substring(1);
        if (tab === 'wheel' || tab === 'alerts') {
          this.activeTab = tab;
        }
      }
    },
  },
};
</script>
